import request from "@/utils/oms-request";

export const getProductCateGory = () =>
    request({
        url: `/product-categories/all-product-category`,
        method: "get"
    });

export const getManagerName = (id: string) =>
    request({
        url: `/product-categories/${id}/manager`,
        method: "get"
    });

export const createProduct = (data: any) =>
    request({
        url: `/products`,
        method: "PUT",
        data
    });

export const editProduct = (id: string, data: any) =>
    request({
       url: `/products/${id}/edit`,
       method: "PUT",
        data
    });

export const getProduct = (id: string) =>
    request({
        url: `/products/${id}`,
        method: "get",
    });

export const createProductCategory = (data: any) =>
    request({
        url: `/product-categories/insert`,
        method: "post",
        data
    });

export const editProductCategory = (id: string,data: any) =>
    request({
        url: `/product-categories/${id}/edit`,
        method: "put",
        data
    });
